/**
 * Delivery Estimation Component
 * Calculates and displays estimated delivery dates based on current time in CEST timezone
 * Handles client-side calculation to avoid Shopify caching issues
 */

class DeliveryEstimation extends HTMLElement {
  constructor() {
    super();
    this.dateElement = this.querySelector('.delivery-date-text');
    if (this.dateElement) {
      this.updateDeliveryDate();
    }
  }

  getCurrentCESTTime() {
    const now = new Date();
    const cestTimeString = now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    const cestTime = new Date(cestTimeString);
    const result = {
      date: cestTime,
      day: cestTime.getDay(),
      hour: cestTime.getHours(),
      timestamp: cestTime.getTime()
    };
    
    return result;
  }

  calculateDeliveryDays() {
    const { day, hour } = this.getCurrentCESTTime();
    let result;
    
    if (day === 0 || day === 6) {
      result = { startDays: 2, endDays: 3 };
      return result;
    }
    
    if (day >= 1 && day <= 3) {
      if (hour < 12) {
        result = { startDays: 1, endDays: 2 };
        return result;
      } else {
        result = { startDays: 2, endDays: 3 };
        return result;
      }
    }
    
    if (day === 4) {
      if (hour < 12) {
        result = { startDays: 1, endDays: 2 };
        return result;
      } else {
        result = { startDays: 2, endDays: 4 };
        return result;
      }
    }
    
    if (day === 5) {
      if (hour < 12) {
        result = { startDays: 1, endDays: 3 };
        return result;
      } else {
        result = { startDays: 3, endDays: 4 };
        return result;
      }
    }

    result = { startDays: 2, endDays: 3 };
    return result;
  }

  formatDate(date) {
    const locale = document.documentElement.lang || 'en';
    const options = { weekday: 'long', day: 'numeric', month: 'long' };

    let formatted;
    
    if (locale === 'de') {
      formatted = date.toLocaleDateString('de-DE', options).replace(',', '');
    } else if (locale === 'fr') {
      formatted = date.toLocaleDateString('fr-FR', options).replace(',', '');
    } else {
      formatted = date.toLocaleDateString('en-US', options).replace(',', '');
    }

    formatted = formatted.replace(
      /^([A-Za-zÀ-ÖØ-öø-ÿ]+)\s+(\d)/,
      '$1, $2'
    );

    return formatted;
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  updateDeliveryDate() {
    const { date } = this.getCurrentCESTTime();
    const { startDays, endDays } = this.calculateDeliveryDays();
    const startDate = this.addDays(date, startDays);
    const endDate = this.addDays(date, endDays);
    const formattedStartDate = this.formatDate(startDate);
    const formattedEndDate = this.formatDate(endDate);
    const template = window.Shopify?.theme?.strings?.delivery_estimation || 'Between {{ start_date }} and {{ end_date }}';
    const deliveryText = template
      .replace('{{ start_date }}', formattedStartDate)
      .replace('{{ end_date }}', formattedEndDate);
    
    this.dateElement.innerHTML = deliveryText;
    this.dataset.startDate = startDate.toISOString();
    this.dataset.endDate = endDate.toISOString();
    this.dataset.calculatedAt = new Date().toISOString();
  }
}

if (!customElements.get('delivery-estimation')) {
  customElements.define('delivery-estimation', DeliveryEstimation);
}

